// Помощници за избор на землище (Е6/Е14). Форматът на стойността в datalist е
// „<село>, община <община>, област <област>, <ЕКАТТЕ>" — ЕКАТТЕ е последната част.

// Ж1: където името на общината/областта се изписва в свободен текст, пред него
// стои и думата. В таблиците с отделна колона „Община" редовете остават чисти.
export const muni = (m) => (m ? `община ${m}` : '');
export const region = (r) => (r ? `област ${r}` : '');

// „с.Краище, община Генерал Тошево, област Добрич" — общият надпис на землище.
export const settlementLabel = (s, {withRegion = true} = {}) => {
    if (!s) return '';
    return [s.settlement, muni(s.municipality), withRegion ? region(s.region) : '']
        .filter(Boolean).join(', ');
};

// Опции за землища с „неопределено" отгоре (псевдо-землищата по общини), после
// останалите в текущия ред. Всяка опция: {id, ekatte, value}.
export const buildSettlementOptions = (settlements) => {
    const opts = (settlements || []).map(s => ({
        id: s.id,
        ekatte: s.ekatte,
        value: `${settlementLabel(s)}, ${s.ekatte}`,
        _top: (s.settlement || '').toLowerCase().includes('неопределено'),
    }));
    return [...opts.filter(o => o._top), ...opts.filter(o => !o._top)];
};

// ЕКАТТЕ от стойността на datalist input-а (последната част след запетая).
export const ekatteFromValue = (val) => (val || '').split(',').pop().trim();

// Стойност за datalist по ЕКАТТЕ (за предпопълване при редакция).
export const valueForEkatte = (settlements, ekatte) => {
    const s = (settlements || []).find(x => x.ekatte === ekatte);
    return s ? `${settlementLabel(s)}, ${s.ekatte}` : (ekatte || '');
};
